export const defaultLogo = "https://cdn.simulanis.io/sso/logos/default_simulanis.png";
export const UNO_URL = 'https://api.simulanis.io';
export const applicationId = "6ceadf8c-c29f-4ae8-a6d6-761850c1ba7a";  